<template>
  <gg-card class="fill-height">
    <gg-card-header>
      Post Ticket Reply
    </gg-card-header>
    <gg-card-text class="px-4">
      <div v-if="!validated">
        <v-textarea
          value="Type here to Reply to Ticket"
          rows="4"
          outlined
          disabled
          background-color="grey"
        />
        <v-card-actions class="pt-0 pl-0">
          <gg-btn
            secondary
            :loading="loading"
            disabled
          >
            Post Reply
          </gg-btn>
        </v-card-actions>
      </div>
      <div v-else>
        <!-- AM-336 - Hide until working to prevent negative feedback.
        <contacts
          :contacts="contacts"
          v-model="model.contacts"
          v-validate="rules.contacts"
          name="contacts"
          data-vv-as="Contacts"
          :error-messages="errors.collect('contacts')"
        /> -->
        <v-textarea
          dense
          class="gg-input"
          placeholder="Type here to Reply to Ticket"
          rows="4"
          outlined
          v-model="model.message"
          v-validate="rules.message"
          data-vv-name="message"
          data-vv-as="Reply"
          :error-messages="errors.collect('message')"
        />
        <v-card-actions class="pt-0 pl-0">
          <div class="d-block">
            <gg-btn
              :loading="loading"
              @click="submitReply"
            >
              Post Reply
            </gg-btn>
          </div>

        </v-card-actions>
        <v-card-actions class="pt-0 pl-0">
          <attachments class="d-block" ref="attachments" @update="setAttachment" />
        </v-card-actions>
      </div>
    </gg-card-text>

  </gg-card>
</template>

<script>
import { mapActions } from 'vuex'
// import Contacts from './Contacts'
import Attachments from '../Common/Attachments'

export default {
  name: 'TicketReply',
  props: {
    ticketid: {
      required: true,
      type: String
    },
    validated: {
      required: true,
      type: Boolean
    },
    contacts: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    loading: false,
    model: {
      contacts: [],
      message: '',
      attachments: []
    },
    rules: {
      contacts: {
        email: true
      },
      message: {
        required: true
      }
    }
  }),
  components: {
  //   Contacts,
    Attachments
  },
  methods: {
    ...mapActions(['sendReply', 'validateTicket', 'reportSuccess', 'reportError']),
    setAttachment (payload) {
      this.model.attachments = payload
    },
    clearData () {
      this.model.message = ''
      this.$refs.attachments.clearAttachments()
    },
    async submitReply () {
      try {
        const valid = await this.$validator.validateAll()
        if (valid) {
          this.loading = true

          const data = {
            reply_body: this.model.message,
            attachments: this.model.attachments,
            action: 'reply',
            ticketmaskid: this.ticketid
          }
          await this.sendReply(data)
          this.loading = false
          this.reportSuccess('Reply posted')
          this.clearData()
        }
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    },
    async validate () {
      try {
        this.loading = true
        const response = await this.validateTicket(this.ticketid)
        this.reportSuccess(response)
        this.loading = false
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    }
  }
}
</script>
